

function setHeight() {
    var flag=false;
	windowHeight = $(window).innerHeight()+20;
	bannerContentMargin = windowHeight /2.4;
    $('.banner').css('height', windowHeight);
    if(flag==false){
        $('.banner>.container').css('height', windowHeight /*- ($('header').innerHeight())*/+20+45);
        flag=true;
    }
    else
        $('.banner>.container').css('height', windowHeight /*- ($('header').innerHeight())+20*/);
};
function temp() {
    $('.template').addClass("sticky");
}
$( window ).resize(function() {
    /*setHeight()*/
    temp()
});
/*setHeight()*/
temp()
var banner = $('.banner').innerHeight()/2
$(window).scroll(function() {
if ($(this).scrollTop() > banner){  
    $('header').addClass("sticky");
  }
  else{
    $('header').removeClass("sticky");
    $('.template').addClass("sticky");
  }

});/*
$(function(){
    // vars for clients list carousel
    // http://stackoverflow.com/questions/6759494/jquery-function-definition-in-a-carousel-script
    var $clientcarousel = $('.carouselinner');
    $clientcarousel.children().each(function () {
         // "this" is the current element in the loop
    });
    var clients = $clientcarousel.children().length;
    /!*console.log(clients);*!/
    var clientwidth = (clients * 180); // 140px width for each client item
    /!*$clientcarousel.css('width',clientwidth);
*!/
    var rotating = true;
    var clientspeed = 3000;
    var seeclients = setInterval(rotateClients, clientspeed);

    $(document).on({
        /!* mouseenter: function(){
         rotating = false; // turn off rotation when hovering
         },
         mouseleave: function(){
         rotating = true;
         }*!/
    }, '#clients');

    function rotateClients() {
        if(rotating != false) {
            var $first = $('.carouselinner .partnerLogo:first');
            var w=$first.width();
            console.log(w);
            $first.animate({ 'margin-right': -1*w}, 1000, function() {
                $first.remove().css({ 'margin-right': '0px' });
                $('.carouselinner .partnerLogo:last').after($first);
            });
        }
    }
});*/


// WEBPACK FOOTER //
// ./js/scripts/scripts.js